module.exports = __webpack_public_path__ + "static/media/einvoice-consolidate.8f643181.svg";